<template lang="pug">
svg.icon-svg(aria-hidden="true", v-bind="$attrs", v-on="$listeners")
  use(v-if="hasSymbol", :xlink:href="iconName")
</template>
<script>
export default {
  name: "IconSvg",
  props: {
    name: {
      default: ""
    }
  },
  computed: {
    svgName() {
      return (this.name || "").trim();
    },
    defaultSvgIcon() {
      return `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="currentColor"><path d="M5.816 11.098L2.94 9.454a.576.576 0 0 0-.842.656.58.58 0 0 0 .27.35l2.876 1.642a.575.575 0 0 0 .787-.217.58.58 0 0 0-.216-.79"/><path d="M12.518 6.293a.58.58 0 0 0-.357-1.078.577.577 0 0 0-.213.07L7.443 7.858 2.941 5.286a.577.577 0 0 0-.842.656.58.58 0 0 0 .27.35l4.568 2.61v5.572a.58.58 0 0 0 .865.501.58.58 0 0 0 .289-.501V8.877c0-.017-.009-.032-.011-.051l4.437-2.533z"/><path d="M13.848 12.33c0 .211-.113.404-.293.508l-5.77 3.292a.572.572 0 0 1-.567 0l-5.77-3.292a.583.583 0 0 1-.294-.507V5.136a.58.58 0 0 1 .287-.501l5.767-3.39a.572.572 0 0 1 .58 0l5.773 3.39a.58.58 0 0 1 .287.501v7.195zm.294-8.703L8.37.237a1.72 1.72 0 0 0-1.742 0L.86 3.627A1.746 1.746 0 0 0 0 5.137v7.195c0 .629.336 1.21.879 1.52l5.769 3.29a1.718 1.718 0 0 0 1.703 0l5.77-3.292c.544-.31.88-.89.879-1.52V5.137a1.75 1.75 0 0 0-.86-1.509h.002z"/><path d="M12.309 7.635L9.616 9.228c-.37.22-.673.706-.673 1.083v3.192c0 .377.301.504.673.284l2.693-1.594c.371-.22.673-.705.673-1.082V7.919c0-.377-.3-.505-.673-.284z"/></svg>`;
    },
    svgEl() {
      const { svgStr } = this;
      if (svgStr) {
        const div = document.createElement("div");
        div.innerHTML = svgStr;
        const svg = div.firstChild;
        if (svg instanceof SVGElement) return div.firstChild;
      }
      return void 0;
    },
    svgStr() {
      if (this.hasSymbol) return "";
      const isSvg = /^<svg\b.*<\/svg>$/i.test(this.svgName);
      return isSvg ? this.svgName : this.defaultSvgIcon;
    },
    iconName() {
      return this.svgName && `#jy-icon-${this.svgName}`;
    },
    hasSymbol() {
      return !!(this.iconName && document.querySelector("symbol" + this.iconName));
    }
  },
  mounted() {
    const { svgEl } = this;
    if (svgEl) {
      for (const attr of svgEl.attributes) {
        this.$el.setAttribute(attr.name, attr.value);
      }
      this.$el.replaceChildren(...svgEl.children);
    }
  }
};
</script>

<style lang="scss" scoped>
.icon-svg {
  height: 1em;
  fill: currentColor;
}
</style>
